import { render, staticRenderFns } from "./RegistrationSuccessCard.vue?vue&type=template&id=247cd134&scoped=true&"
import script from "./RegistrationSuccessCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationSuccessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cd134",
  null
  
)

export default component.exports